export default __webpack_public_path__ + "static/media/2309.7318eb11.png";